// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-32db0b00]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.intervention_apply[data-v-32db0b00] {\n  font-size: 14px;\n}\n.intervention_apply > div[data-v-32db0b00] {\n  line-height: 30px;\n}", ""]);
// Exports
module.exports = exports;
